import { Anchor, Box } from 'grommet';
import { DocumentText, Trash } from 'grommet-icons';
import { actions } from 'modules/asset/asset$';
import { User } from 'modules/auth/types';
import { colors } from 'modules/root/theme';
import React, { useEffect, useState } from 'react';
import { dispatchAction } from 'rxbeach';
import { connect } from 'rxbeach/react';
import { docUrl } from 'services/doc';
import { ApiServiceState } from 'streams/crudStream/types';
import styled from 'styled-components';
import { Asset } from 'types';
import DocumentUploader from '../fileHandler/DocumentUploader';
import viewModel$ from '../viewModel$';

const Trashcan = styled(Trash as unknown as any)`
  :hover {
    color: red;
  }
  cursor: pointer;
`;

const PrettyBox = styled(Box)`
  background: #eee;
  padding: 16px;
  margin: 16px;
  border-radius: 8px;
`;

/* Files are stored with an id with length 6, seperated with a dash
 * Remove this ugly id in the view
 */
const formatFiles = (text: string) => {
  if (text.indexOf('-') !== 6) return text;
  return text.substring(7, text.length);
};

const removeAttachment = (asset: Asset, attachment: string) => {
  dispatchAction(
    actions.apiPut([
      {
        ...asset,
        attachments: (asset.attachments || []).filter((a) => a !== attachment),
      },
    ])
  );
};

const addAttachment = (asset: Asset, attachment: string) => {
  dispatchAction(
    actions.apiPut([
      {
        ...asset,
        attachments: [...(asset.attachments || []), attachment],
      },
    ])
  );
};

interface FileActionEditorProps {
  id: string;
  user: User | null;
  byId: Record<string, Asset>;
  state: ApiServiceState;
}

const FileActionEditor = ({ id, byId, user }: FileActionEditorProps) => {
  const asset = byId?.[id];
  const [key, setKey] = useState('');
  useEffect(() => {
    if (!key) return;
    addAttachment(asset, key);
  }, [key]);
  return (
    <Box>
      {user && <DocumentUploader onSuccess={(key) => setKey(key)} />}
      {asset.attachments?.map((attachment, i) => (
        <PrettyBox key={attachment + i} direction="row" justify="between">
          <Anchor
            href={`${docUrl()}${attachment}`}
            target="_blanc"
            size="medium"
            label={formatFiles(attachment)}
            icon={<DocumentText />}
          />
          {user && (
            <Trashcan
              color={colors.danger.color}
              size="medium"
              onClick={() => removeAttachment(asset, attachment)}
            />
          )}
        </PrettyBox>
      ))}
    </Box>
  );
};

export default connect(FileActionEditor, viewModel$);
